export default {
    LOAD_COUPONS (state, store_coupon) {
        state.items = store_coupon
    },
    LOAD_COUPON (state, store_coupon) {
        state.item = store_coupon
    }
}